import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';
import { workRegisterKeys } from './workRegisters.key';

type Options = {
  onDeleteFileSuccess?: () => void;
  onDeleteFileError?: (error: unknown) => void;
};

export function useDeletePersonnelFile(
  personnelId: string,
  controlId: string,
  options?: Options
) {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const deleteFile = async ({
    personnelFileId,
  }: {
    personnelFileId: string;
  }) => {
    const api = await getApi();

    const res = await api.personnelFilesDelete(personnelFileId);
    return res.data;
  };

  const onSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: workRegisterKeys.personnelFindOneFiles(controlId, personnelId),
    });
    options?.onDeleteFileSuccess?.();
  };

  const onError = (error: unknown) => {
    toast.error('Error, bilden gick inte att radera');

    options?.onDeleteFileError?.(error);
  };

  const mutation = useMutation(deleteFile, {
    onSuccess,
    onError,
  });

  return mutation;
}
